import React from 'react'
import './AppMenu.css'

export interface AppMenuCategoryProps {
  caption?: React.ReactNode
  children?: React.ReactNode
  itemWidth: number
  itemHeight: number
  gap: number
}

export default function AppMenuCategory(props: AppMenuCategoryProps) {
  return (
    <div>
      <h3 className="pcy-app-menu-category-caption">{props.caption}</h3>
      <ul className="pcy-app-menu-category-container" style={{ gap: props.gap }}>
        {React.Children.map(props.children, child => {
          return (
            <li
              className="pcy-app-menu-category-item-container"
              style={{ width: props.itemWidth, height: props.itemHeight }}>
              {child}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
